import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
export function showFileExistsDialog(t, fileName, fileEntityType) {
    showAlertDialog({
        title: t('restoreFileDialog.restoredFailedTitle', { fileName }),
        content: t('fileExistsDialog.content', { fileEntityType: fileEntityType.toLowerCase() }),
    });
}
